/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2019-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {
  useLocation, useNavigate, useParams, useSearchParams, Search, NavigateFunction, Params,
} from 'react-router-dom';

export type WithRouterProps = {
  router: {
    location: Location,
    navigate: NavigateFunction,
    search: Search,
    readonly params: Params<string>
  }
};

/**
 * HOC to provide router functionality to class components
 * @param WrappedComponent - the component which requires the router functionality
 */
function withRouter<T extends WithRouterProps>(WrappedComponent: React.ComponentType<T>) {
  function ComponentWithRouterProps(props: any) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const [search] = useSearchParams();
    return (
      <WrappedComponent
        {...props}
        router={{ location, navigate, params, search }}
      />
    );
  }

  return ComponentWithRouterProps;
}

export const withRouterPropTypes = PropTypes.shape({
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object.isRequired,
  navigate: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  params: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  search: PropTypes.object,
});

export default withRouter;
